import {extend} from "flarum/extend";
import SessionDropdown from "flarum/components/SessionDropdown";
import Button from "flarum/components/Button";

/**
 * Replace original logout button with functionality for logging out of
 * UniLogin.
 */
export default function (env = 'forum') {
  extend(SessionDropdown.prototype, 'items', function (items) {
    if (items.has('logOut')) {
      let label = 'core.forum.header.log_out_button';

      if (env === 'admin') {
        label = 'core.admin.header.log_out_button';
      }

      items.replace('logOut',
        Button.component({
          icon: 'fas fa-sign-out-alt',
          onclick: function () {
            const baseUrl = app.forum.attribute('baseUrl');
            // Subdomain is empty for localhost
            const subdomain = app.forum.attribute('subdomain') && app.forum.attribute('subdomain') !== ""
              ? `/${app.forum.attribute("subdomain")}`
              : "";
            const csfrToken = app.session.csrfToken;
            const url = `${baseUrl}/logout?return=${subdomain}/auth/unilogin/sls&token=${csfrToken}`;

            if (sessionStorage.getItem('preferred_skip_check')) {
              sessionStorage.removeItem('preferred_skip_check');
            }

            window.location.replace(url)
          }
        }, app.translator.trans(label)),
        -100
      );
    }
  });
}
